<template>
  <div>
    <v-dialog
      max-width="850px"
      v-model="openDialogPushNotice"
      persistent
      scrollable
      transition="dialog-bottom-transition"
    >
      <v-card tile>
        <v-toolbar flat dark color="rgb(51, 97, 137)">
          <v-toolbar-title>
            <v-icon left>mdi-bell-ring</v-icon>
            {{ $vuetify.lang.t('$vuetify.eventManagement.addEditEvent') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn right icon dark :disabled="loading" @click="clearForm">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-3">
          <v-form ref="form" v-model="valid">
            <v-row
              v-if="
                typeNotice == 'COURSE' ||
                typeNotice == 'LIVE' ||
                typeNotice == 'EXAM'
              "
            >
              <v-col cols="12" class="pt-4 pb-0">
                <p class="title pb-0">
                  {{ $vuetify.lang.t('$vuetify.eventManagement.chooseCourse') }}
                  <span class="red--text">*</span>
                </p>
                <v-autocomplete
                  :disabled="from == 'live_dashboard'"
                  v-model="selectCourse"
                  :items="courseList"
                  item-text="title"
                  item-value="id"
                  outlined
                  :placeholder="
                    $vuetify.lang.t('$vuetify.eventManagement.chooseCourse')
                  "
                  :rules="selectCourseRules"
                  background-color="white"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <div>
              <v-row
                v-if="
                  !(typeNotice === 'GENERAL') &&
                  !(typeNotice === 'COURSE') &&
                  !(typeNotice === 'URL')
                "
              >
                <v-col cols="12" class="py-0">
                  <p v-if="typeNotice == 'COURSE'" class="title pb-0">
                    {{
                      $vuetify.lang.t('$vuetify.eventManagement.chooseCourse')
                    }}
                    <span class="red--text">*</span>
                  </p>
                  <p v-if="typeNotice == 'LIVE'" class="title pb-0">
                    {{ $vuetify.lang.t('$vuetify.eventManagement.chooseLive') }}
                    <span class="red--text">*</span>
                  </p>
                  <p v-if="typeNotice == 'EXAM'" class="title pb-0">
                    {{ $vuetify.lang.t('$vuetify.eventManagement.chooseExam') }}
                    <span class="red--text">*</span>
                  </p>
                  <v-autocomplete
                    v-if="typeNotice == 'COURSE'"
                    v-model="selectSub"
                    :items="subList"
                    item-text="title"
                    item-value="id"
                    outlined
                    :placeholder="
                      $vuetify.lang.t('$vuetify.eventManagement.chooseCourse')
                    "
                    :rules="selectCourseRules"
                    background-color="white"
                    :disabled="selectCourse === ''"
                  ></v-autocomplete>
                  <v-autocomplete
                    v-if="typeNotice == 'LIVE'"
                    v-model="selectSub"
                    :items="subList"
                    item-text="title"
                    item-value="id"
                    outlined
                    :placeholder="
                      $vuetify.lang.t('$vuetify.eventManagement.chooseLive')
                    "
                    :rules="selectCourseRules"
                    background-color="white"
                    :disabled="selectCourse === '' || from == 'live_dashboard'"
                  ></v-autocomplete>
                  <v-autocomplete
                    v-if="typeNotice == 'EXAM'"
                    v-model="selectSub"
                    :items="subList"
                    item-text="title"
                    item-value="id"
                    outlined
                    :placeholder="
                      $vuetify.lang.t('$vuetify.eventManagement.chooseExam')
                    "
                    :rules="selectCourseRules"
                    background-color="white"
                    :disabled="selectCourse === ''"
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="pb-0" :cols="12">
                  <p class="title pb-0">
                    {{ $vuetify.lang.t('$vuetify.eventManagement.eventName') }}
                    <span class="red--text">*</span>
                  </p>
                  <v-text-field
                    outlined
                    :rules="titleRules"
                    clearable
                    class="textField pb-0"
                    :placeholder="
                      $vuetify.lang.t('$vuetify.eventManagement.eventName')
                    "
                    v-model="title"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="typeNotice == 'URL'">
                <v-col class="pb-0" :cols="12">
                  <p class="title pb-0">
                    {{ $vuetify.lang.t('$vuetify.eventManagement.link') }}
                    <span class="red--text">*</span>
                  </p>
                  <v-text-field
                    prefix="https://"
                    outlined
                    @change="clearUrl"
                    :rules="url ? [urlRules] : []"
                    clearable
                    class="textField pb-0"
                    :placeholder="
                      $vuetify.lang.t('$vuetify.eventManagement.link')
                    "
                    v-model="url"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <p class="title pb-0">
                    {{ $vuetify.lang.t('$vuetify.eventManagement.detail') }}
                  </p>
                  <v-textarea
                    solo
                    no-resize
                    flat
                    class="subtitle-2 font-weight-light textarea-border"
                    :placeholder="
                      $vuetify.lang.t('$vuetify.eventManagement.detail')
                    "
                    height="65px"
                    v-model="message"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pt-4">
                  <p class="title pb-0">
                    {{ $vuetify.lang.t('$vuetify.eventManagement.image') }}
                  </p>

                  <div class="img-list-preview">
                    <v-row>
                      <v-col cols="4">
                        <div class="img-panel">
                          <v-img
                            :src="imgPreview"
                            :lazy-src="imgPreview"
                            aspect-ratio="1.7"
                            contain
                            height="115px"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-icon
                                  v-if="imgPreview === ''"
                                  class="mx-auto"
                                  elevation="3"
                                  size="80"
                                  color="grey "
                                  >mdi-image</v-icon
                                >
                              </v-row>
                            </template>
                          </v-img>
                        </div>
                      </v-col>
                      <v-col cols="8"
                        ><v-row class="mt-0 mb-1 ml-6">
                          <v-col class="pl-0 py-0" cols="12">
                            <p class="mb-0">
                              {{ imageName }}
                            </p>
                          </v-col>
                        </v-row>
                        <div class="upload-btn-wrapper">
                          <button class="btn-choose body-1 font-weight-medium">
                            <v-icon>mdi-upload</v-icon
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.eventManagement.chooseFile'
                              )
                            }}
                          </button>
                          <input
                            type="file"
                            name="myfile"
                            @change="preview"
                            accept="image/png, image/jpeg, image/bmp"
                          />
                        </div>
                        <p class="mb-0 text-custom body-2 font-weight-regular">
                          {{
                            $vuetify.lang.t('$vuetify.eventManagement.msg.msg1')
                          }}
                        </p>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="from != 'live_dashboard'">
                <v-col cols="12">
                  <p class="title mb-0">
                    {{ $vuetify.lang.t('$vuetify.eventManagement.target') }}
                    <span class="red--text">*</span>
                  </p>
                  <v-row>
                    <v-col cols="12">
                      <v-radio-group
                        v-model="targetSend"
                        row
                        hide-details
                        @change="checkTarget()"
                      >
                        <v-radio
                          :label="
                            $vuetify.lang.t(
                              '$vuetify.eventManagement.allOrganization'
                            )
                          "
                          value="all-org"
                        ></v-radio>
                        <v-radio
                          :label="
                            $vuetify.lang.t(
                              '$vuetify.eventManagement.courseUsergroup'
                            )
                          "
                          value="course-usergroup"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row
                v-if="
                  targetSend == 'course-usergroup' || from != 'live_dashboard'
                "
              >
                <v-col cols="6" v-if="from != 'live_dashboard'">
                  <p class="subtitle-1 mb-0">
                    {{
                      $vuetify.lang.t('$vuetify.eventManagement.chooseCourse')
                    }}
                  </p>
                  <v-combobox
                    v-model="arrCourseId"
                    :items="courseList"
                    item-text="title"
                    item-value="id"
                    :placeholder="
                      $vuetify.lang.t('$vuetify.eventManagement.chooseCourse')
                    "
                    outlined
                    dense
                    multiple
                    required
                    small-chips
                    background-color="white"
                  >
                    <template
                      v-slot:selection="{ attrs, item, parent, selected }"
                    >
                      <v-chip
                        class="ma-1"
                        v-if="item === Object(item)"
                        v-bind="attrs"
                        :input-value="selected"
                        label
                        small
                      >
                        <span class="pr-2">
                          {{ item.title }}
                        </span>
                        <v-icon small @click="parent.selectItem(item)">
                          mdi-close-circle
                        </v-icon>
                      </v-chip>
                    </template></v-combobox
                  >
                </v-col>
                <v-col cols="6" v-if="from != 'live_dashboard'">
                  <p class="subtitle-1 mb-0">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.eventManagement.chooseUserGroup'
                      )
                    }}
                  </p>
                  <v-combobox
                    v-model="arrUsergroupId"
                    :items="arrayGroup"
                    item-text="title"
                    item-value="_id"
                    :placeholder="
                      $vuetify.lang.t(
                        '$vuetify.eventManagement.chooseUserGroup'
                      )
                    "
                    outlined
                    dense
                    multiple
                    required
                    small-chips
                    background-color="white"
                  >
                    <template
                      v-slot:selection="{ attrs, item, parent, selected }"
                    >
                      <v-chip
                        class="ma-1"
                        v-if="item === Object(item)"
                        v-bind="attrs"
                        :input-value="selected"
                        label
                        small
                      >
                        <span class="pr-2">
                          {{ item.title }}
                        </span>
                        <v-icon small @click="parent.selectItem(item)">
                          mdi-close-circle
                        </v-icon>
                      </v-chip>
                    </template></v-combobox
                  >
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <p class="title mb-0">
                    {{ $vuetify.lang.t('$vuetify.eventManagement.platform') }}
                    <span class="red--text">*</span>
                  </p>
                  <v-row>
                    <v-col cols="12">
                      <v-radio-group v-model="platform" row>
                        <v-radio
                          :label="
                            $vuetify.lang.t(
                              '$vuetify.eventManagement.allPlatform'
                            )
                          "
                          value="all"
                        ></v-radio>
                        <v-radio
                          :label="
                            $vuetify.lang.t('$vuetify.eventManagement.ios')
                          "
                          value="ios"
                        ></v-radio>
                        <v-radio
                          :label="
                            $vuetify.lang.t('$vuetify.eventManagement.android')
                          "
                          value="android"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <p class="title mb-0">
                    {{ $vuetify.lang.t('$vuetify.eventManagement.timeEvent') }}
                    <span class="red--text">*</span>
                  </p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="5">
                  <div class="set-date-exam-start">
                    <div
                      class="datetime d-flex align-center justify-between mb-5"
                    >
                      <span class="subtitle-1 font-weight-light"
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.start'
                          )
                        }}:</span
                      >
                      <datetime
                        :disabled="from == 'live_dashboard'"
                        ref="search_start_date"
                        type="datetime"
                        input-id="startDate"
                        rules="startTimeRule"
                        v-model="startTime"
                        format="dd/MM/yyyy HH:mm:ss"
                        :placeholder="
                          $vuetify.lang.t(
                            '$vuetify.eventManagement.eventStartTime'
                          )
                        "
                        class="subtitle-1 font-weight-light ml-3 exam-date"
                      ></datetime>
                      <v-icon
                        :disabled="from == 'live_dashboard'"
                        class="icon-calendar"
                        @click="open_calender($event, 'search_start_date')"
                        >mdi-calendar-text</v-icon
                      >
                    </div>
                  </div>
                </v-col>
                <v-col cols="5">
                  <div class="set-date-exam-end">
                    <div class="datetime d-flex align-center justify-between">
                      <span class="subtitle-1 font-weight-light"
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.end'
                          )
                        }}:</span
                      >
                      <datetime
                        :disabled="from == 'live_dashboard'"
                        ref="search_end_date"
                        type="datetime"
                        rules="endDateRule"
                        input-id="endDate"
                        v-model="endTime"
                        format="dd/MM/yyyy HH:mm:ss"
                        :placeholder="
                          $vuetify.lang.t(
                            '$vuetify.eventManagement.eventEndTime'
                          )
                        "
                        class="subtitle-1 font-weight-light ml-3 exam-date"
                      >
                      </datetime>
                      <v-icon
                        :disabled="from == 'live_dashboard'"
                        class="icon-calendar"
                        @click="open_calender($event, 'search_end_date')"
                        >mdi-calendar-text</v-icon
                      >
                    </div>
                    <div class="mt-5" v-if="endTime <= startTime">
                      <span class="red--text"
                        >*{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.scheduleInstruction'
                          )
                        }}</span
                      >
                    </div>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="from != 'live_dashboard'">
                <v-col cols="12">
                  <p class="title mb-0">
                    {{ $vuetify.lang.t('$vuetify.eventManagement.alert') }}
                    <span class="red--text">*</span>
                  </p>
                  <v-row>
                    <v-col cols="9" class="pr-0">
                      <v-radio-group
                        :disabled="chekAlert == true"
                        v-model="schedule"
                        row
                        class="py-0 mt-2"
                      >
                        <v-layout>
                          <v-flex>
                            <v-radio
                              :label="
                                $vuetify.lang.t(
                                  '$vuetify.eventManagement.notSending'
                                )
                              "
                              value="notsend"
                            ></v-radio>
                          </v-flex>
                          <v-flex>
                            <v-radio
                              :label="
                                $vuetify.lang.t(
                                  '$vuetify.eventManagement.sendNow'
                                )
                              "
                              value="sendnow"
                            ></v-radio>
                          </v-flex>
                          <v-flex>
                            <v-radio
                              :label="
                                $vuetify.lang.t(
                                  '$vuetify.eventManagement.sendOnEventTime'
                                )
                              "
                              value="sendeventtime"
                            ></v-radio>
                          </v-flex>
                          <v-flex>
                            <v-radio
                              :label="
                                $vuetify.lang.t(
                                  '$vuetify.eventManagement.customTime'
                                )
                              "
                              value="custom"
                            ></v-radio>
                          </v-flex>
                        </v-layout>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="3" class="px-0" v-if="schedule === 'custom'">
                      <div
                        class="
                          datetime
                          d-flex
                          align-center
                          justify-between
                          mb-5
                        "
                      >
                        <datetime
                          :disabled="chekAlert == true"
                          type="datetime"
                          input-id="sendTime"
                          rules="timeRule"
                          v-model="sendTime"
                          format="dd/MM/yyyy HH:mm:ss"
                          :placeholder="
                            $vuetify.lang.t(
                              '$vuetify.eventManagement.selectDate'
                            )
                          "
                          class="subtitle-1 font-weight-light ml-3"
                          :min="nowdate"
                        ></datetime>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="
              px-9
              ma-2
              subtitle-2
              button-secondary
              font-weight-light
              text-capitalize
            "
            outlined
            :disabled="loading"
            @click="clearForm"
            >{{ $vuetify.lang.t('$vuetify.eventManagement.cancel') }}</v-btn
          >
          <v-btn
            elevation="0"
            class="
              px-10
              ma-2
              subtitle-2
              text-capitalize
              font-weight-light
              button-primary
            "
            :disabled="
              loading == true ||
              title == '' ||
              startTime == '' ||
              endTime == '' ||
              isSendtimeMorethanCurrent == false
            "
            :loading="loading"
            @click="sendNotification()"
            >{{
              from == 'live_dashboard'
                ? $vuetify.lang.t('$vuetify.eventManagement.send')
                : $vuetify.lang.t('$vuetify.eventManagement.save')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmSendNoticeDialog" max-width="350">
      <v-card class="pt-10">
        <v-card-text> {{ messageConfirmSendNotice }} </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light"
            @click="confirmSendNoticeDialog = false"
          >
            {{ $vuetify.lang.t('$vuetify.eventManagement.cancel') }}
          </v-btn>
          <v-btn
            class="
              px-10
              ma-2
              subtitle-2
              text-capitalize
              font-weight-light
              button-primary
            "
            @click="sendNotification()"
          >
            {{ $vuetify.lang.t('$vuetify.eventManagement.ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { getUserGroup } from '@/service/account/manageUser';

import { getCourse } from '@/service/course/course';
import { getLive } from '@/service/course/livev2';
import {
  createNotice,
  createNoticeWithSendTime,
  getExamListInCourse,
  updateNotice,
  createNoticeToSendNow,
} from '@/service/notification/notification';
import { Datetime } from 'vue-datetime';
import axios from 'axios';
import { headersWithTokenForImage, domain } from '@/service/configApi';
export default {
  name: 'push-notification',
  components: {
    datetime: Datetime,
  },
  props: {
    openDialogPushNotice: {
      type: Boolean,
    },
    closePushNoticeDialog: {
      type: Function,
    },
    startStream: {
      type: Function,
    },
    courseId: {
      type: String,
    },
    subId: {
      type: String,
    },
    liveId: {
      type: String,
    },
    titleNotice: {
      type: String,
    },
    messageNotice: {
      type: String,
    },
    urlNotice: {
      type: String,
    },
    typeNotice: {
      type: String,
    },
    typeSpecial: {
      type: String,
    },
    examId: {
      type: String,
    },
    noticeId: {
      type: String,
    },
    imageNotice: {
      type: String,
    },
    timeSendNotice: {
      type: Number,
    },
    platformNotice: {
      type: String,
    },
    targetNotice: {
      type: String,
    },
    event: {
      type: Object,
    },
    courses: {
      type: Array,
    },
    usergroup: {
      type: Array,
    },
    alertNotice: {
      type: Boolean,
    },
    stausNotice: {
      type: String,
    },
    from: {
      type: String,
    },
    liveStartTime: {
      type: Number,
    },
    liveEndTime: {
      type: Number,
    },
  },
  data() {
    return {
      titleRules: [(v) => !!v || 'กรุณากรอกชื่อกิจกรรม'],
      urlRules: [(v) => !!v || 'กรุณากรอก Url'],
      messageRules: [(v) => !!v || 'กรุณากรอกรายละเอียด หรือข้อความแจ้งเตือน'],
      selectCourseRules: [
        (v) => !!v || 'กรุณาเลือกคอร์ส',
        // v => (v && v.length >= 2) || "Category must be at least 2 characters"
      ],

      loading: false,
      title: '',
      message: '',
      url: '',
      targetSend: 'all-org',
      platform: 'all',
      schedule: 'notsend',
      params: {},
      startTime: '',
      endTime: '',
      chekAlert: null,
      page: 1,
      limit: 100,

      // searchInput: '',
      // searchData: '',
      userSearch: [],

      arrCourseId: [],
      arrUsergroupId: [],

      alertDuplicate: false,
      sendTime: '',
      messageConfirmSendNotice: '',
      confirmSendNoticeDialog: false,

      imageFile: null,
      imgPreview: '',
      imageReady: false,
      imgBool: false,

      searchInputCourse: '',
      searchDataCourse: '',
      selectCourse: [],
      courseList: [],

      searchInputSub: '',
      searchDataSub: '',
      selectSub: [],
      subList: [],

      isSendtimeMorethanCurrent: true,
      alertDatetime: false,

      nowdate: new Date().toISOString().substr(0, 10),
    };
  },
  mounted() {
    this.initialize();
  },
  computed: {
    timeRule() {
      const rules = [];

      if (this.schedule === 'custom') {
        const rule = (v) => !!v || 'กรุณาระบุวัน เวลา ส่งแจ้งเตือน';
        rules.push(rule);
      }
      return rules;
    },
    headerUser() {
      return [
        {
          text: 'ส่งแจ้งเตือนไปยัง',
          value: 'name',
          sortable: false,
        },
        {
          text: '',
          value: 'actions',
          align: 'end',
          sortable: false,
        },
      ];
    },
  },
  watch: {
    openDialogPushNotice: async function (newValue) {
      if (newValue) {
        await this.getCourseList();
        await this.getUserGroupList();
        if (this.noticeId || this.from == 'live_dashboard') {
          this.selectCourse = this.courseId;

          if (this.typeNotice === 'LIVE' || this.typeNotice === 'EXAM') {
            this.selectSub = this.subId;
          }
          if (this.stausNotice) {
            this.schedule = this.stausNotice;
          } else if (this.timeSendNotice == 0) {
            this.schedule = 'notsend';
          } else {
            this.schedule = 'custom';
          }

          this.title = this.titleNotice;

          this.message = this.messageNotice;

          this.url = this.urlNotice;
          this.imgPreview = this.imageNotice;
          this.targetSend = this.targetNotice;
          this.platform = this.platformNotice;
          this.imageReady = true;
          this.chekAlert = this.alertNotice;

          this.sendTime =
            this.sendTime == 0
              ? ''
              : new Date(this.timeSendNotice).toISOString();
          console.log('this.event', this.event);
          if (this.from == 'live_dashboard') {
            this.startTime = new Date(this.liveStartTime).toISOString();

            this.endTime = new Date(this.liveEndTime).toISOString();
          } else {
            this.startTime = new Date(this.event.startTime).toISOString();
            this.endTime = new Date(this.event.endTime).toISOString();
          }

          let arrcourses = [];
          if (this.courses) {
            this.courses.forEach((element) => {
              arrcourses.push(element);
            });
            arrcourses.forEach((course) => {
              let itemCourse = this.courseList.find((sub) => sub.id === course);
              this.arrCourseId.push(itemCourse);
            });
          } else {
            let itemCourse = this.courseList.find(
              (sub) => sub.id === this.courseId
            );
            this.arrCourseId.push(itemCourse);
          }

          let arrusergroup = [];
          if (this.usergroup) {
            this.usergroup.forEach((element) => {
              arrusergroup.push(element);
            });
            arrusergroup.forEach((group) => {
              let itemGroup = this.arrayGroup.find((sub) => sub._id === group);
              this.arrUsergroupId.push(itemGroup);
            });
          }
        } else {
          this.selectCourse = [];
          this.selectSub = [];
          this.params = {
            page: 1,
            limit: 30,
            search: '',
            sort: 'created_at',
            sortby: '-1',
          };
        }
      }
    },
    sendTime() {
      if (Date.now() < new Date(this.sendTime).getTime()) {
        this.isSendtimeMorethanCurrent = true;
        this.alertDatetime = false;
      } else if (Date.now() > new Date(this.sendTime).getTime()) {
        this.isSendtimeMorethanCurrent = false;
      }
    },
    startTime() {
      if (Date.now() < new Date(this.startTime).getTime()) {
        this.isSendtimeMorethanCurrent = true;
        this.alertDatetime = false;
      } else if (Date.now() > new Date(this.startTime).getTime()) {
        this.isSendtimeMorethanCurrent = false;
      }
    },
    endTime() {
      if (Date.now() < new Date(this.endTime).getTime()) {
        this.isSendtimeMorethanCurrent = true;
        this.alertDatetime = false;
      } else if (Date.now() > new Date(this.endTime).getTime()) {
        this.isSendtimeMorethanCurrent = false;
      }
    },
    async selectCourse() {
      if (this.selectCourse.length > 0) {
        if (this.noticeId) {
          if (this.typeNotice === 'LIVE') {
            this.courseId = this.selectCourse;
            await this.getLiveList();
          } else if (this.typeNotice === 'EXAM') {
            this.courseId = this.selectCourse;
            await this.getExamList();
          } else if (this.typeNotice === 'COURSE') {
            this.courseId = this.selectCourse;
          }
        } else {
          if (this.typeNotice === 'LIVE') {
            this.courseId = this.selectCourse;
            await this.getLiveList();
          } else if (this.typeNotice === 'EXAM') {
            this.courseId = this.selectCourse;

            await this.getExamList();
          } else if (this.typeNotice === 'COURSE') {
            this.courseId = this.selectCourse;
          }
        }
      } else {
        // if (this.typeNotice === 'LIVE') {
        this.courseId = this.selectCourse;
        // await this.getLiveList();
        // } else if (this.typeNotice === 'EXAM') {
        //   this.courseId = this.selectCourse;

        // await this.getExamList();
        // } else if (this.typeNotice === 'COURSE') {
        //   this.courseId = this.selectCourse;
        // }
      }
    },
    selectSub() {
      if (this.selectSub.length > 0) {
        if (this.typeNotice === 'LIVE') {
          this.liveId = this.selectSub;
        } else if (this.typeNotice === 'EXAM') {
          this.examId = this.selectSub;
        }
      }
    },

    schedule(val) {
      if (val === 'sendnow' || val === 'notsend') {
        this.isSendtimeMorethanCurrent = true;
      } else if (val === 'custom' && this.noticeId) {
        this.sendTime = new Date(this.timeSendNotice).toISOString();
        this.isSendtimeMorethanCurrent = true;
      }

      // else if (val === 'custom') {
      //   this.isSendtimeMorethanCurrent = false;
      //   let oneDayMilli = 86400000;
      //   let currentDate = new Date();
      //   let initStartDateMilli = new Date(currentDate.getTime()).toISOString();
      //   let initEndDateMilli = new Date(
      //     currentDate.getTime() + oneDayMilli
      //   ).toISOString();
      // }
      else if (val === 'sendeventtime') {
        if (Date.now() > new Date(this.startTime).getTime()) {
          this.isSendtimeMorethanCurrent = false;
        }
      }
    },
  },
  methods: {
    async initialize() {},
    open_calender(event, which) {
      this.$refs[which].open(event);
    },
    checkTarget() {
      if (this.targetSend == 'all-org') {
        this.arrCourseId = [];
        this.arrUsergroupId = [];
      }
    },

    async getCourseList() {
      let result = await getCourse({
        sort: 'created_at',
        sortby: -1,
        page: 1,
        limit: 100,
        active: null,
      });
      this.courseList = [];
      result.data.forEach((course) => {
        this.courseList.push({
          id: course._id,
          title: course.title,
        });
      });
    },
    async getLiveList() {
      let offset = `${(this.page - 1) * this.limit},${this.limit}`;
      let result = await getLive({
        course: this.courseId,
        filter: 'all',
        offset,
        sortBy: 'created_at',
        sortOrder: -1,
        search: '',
      });
      this.subList = [];
      result.data.forEach((sub) => {
        this.subList.push({
          id: sub._id,
          title: sub.title,
        });
      });
    },
    async getExamList() {
      let result = await getExamListInCourse({
        idcourse: this.courseId,
      });
      this.subList = [];

      result.forEach((sub) => {
        this.subList.push({
          id: sub._id,
          title: sub.title,
        });
      });
    },
    async getUserGroupList() {
      let result = await getUserGroup(this.paramsG);

      this.groupUsers = [];

      this.arrayGroup = [];
      await result.forEach(async (group) => {
        group.child_User_Group.length === 0
          ? await this.arrayGroup.push({
              title: group.title,
              _id: group._id,
            })
          : null;
        group.child_User_Group.forEach(async (child) => {
          child.child_User_Group.length === 0
            ? await this.arrayGroup.push({
                title: group.title + ' -> ' + child.title,
                _id: child._id,
              })
            : null;
          child.child_User_Group.forEach(async (lastChild) => {
            await this.arrayGroup.push({
              title:
                group.title + ' -> ' + child.title + ' -> ' + lastChild.title,
              _id: lastChild._id,
            });
          });
        });
      });

      this.groupUsers = result;
      await this.arrayGroup.filter((group) => group.active === true);
    },
    async preview(event) {
      let file = event.target.files[0];

      this.imageFile = file;
      this.imgPreview = await URL.createObjectURL(file);
      this.imageName = file.name;
      if (this.imgPreview) {
        this.imageReady = true;
      }
      this.imgBool = true;
    },

    clearForm() {
      this.title = '';
      this.message = '';
      this.url = '';
      this.targetSend = 'all-org';
      this.platform = 'all';
      this.schedule = 'notsend';
      this.chekAlert = null;

      this.userSearch = [];
      this.arrCourseId = [];
      this.arrUsergroupId = [];

      this.alertDuplicate = false;
      this.sendTime = '';
      this.messageConfirmSendNotice = '';
      this.confirmSendNoticeDialog = false;

      this.imageFile = null;
      this.imgPreview = '';
      this.imageName = '';
      this.imageReady = false;
      this.imgBool = false;

      this.searchInputCourse = '';
      this.searchDataCourse = '';
      this.selectCourse = [];
      this.courseList = [];

      this.searchInputSub = '';
      this.searchDataSub = '';
      this.selectSub = [];
      this.subList = [];

      this.isSendtimeMorethanCurrent = true;
      this.alertDatetime = false;
      this.startTime = '';
      this.endTime = '';
      this.loading = false;

      this.$refs.form.resetValidation();
      this.closePushNoticeDialog();
      // this.initialize();
    },

    confirmDelete(item) {
      let idx = this.userSelect.findIndex((user) => user.id === item.id);
      this.userSelect.splice(idx, 1);
    },

    async sendNotification() {
      if (this.noticeId) {
        if (this.imageFile != null) {
          await this.uploadImg(this.imageFile);
          await this.saveNotice();
        } else {
          await this.saveNotice();
        }
      } else if (this.from == 'live_dashboard') {
        if (this.imageFile != null) {
          await this.uploadImg(this.imageFile);
        }
        await this.createNoticeToSendNow();
      } else {
        if (this.imageFile != null) {
          await this.uploadImg(this.imageFile);
          await this.insertNotice();
        } else {
          await this.insertNotice();
        }
      }
      this.confirmSendNoticeDialog = false;

      this.clearForm();
      this.closePushNoticeDialog();
    },
    async createNoticeToSendNow() {
      this.loading = true;

      if (this.$refs.form.validate()) {
        let sendTimeMiili = null;
        let startTime = new Date(this.startTime).getTime();
        let endTime = new Date(this.endTime).getTime();

        let arrcourses = [];
        if (this.arrCourseId.length > 0) {
          this.arrCourseId.forEach((element) => {
            arrcourses.push(element.id);
          });
        }
        let arrusergroup = [];
        if (this.arrUsergroupId.length > 0) {
          this.arrUsergroupId.forEach((element) => {
            arrusergroup.push(element._id);
          });
        }
        let body = {
          title: this.title,
          body: this.message,
          url: this.url,
          image: this.imgPreview,
          target: this.targetSend,
          platform: this.platform,
          statusNotification: this.schedule,
          timesend: sendTimeMiili,
          event: {
            startTime: startTime,
            endTime: endTime,
          },
          courses: this.targetSend == 'course-usergroup' ? arrcourses : [],
          usergroup: this.targetSend == 'course-usergroup' ? arrusergroup : [],
          company:
            this.targetSend == 'all-org' ? this.$store.state.company._id : null,
        };

        if (this.typeNotice == 'LIVE') {
          body = {
            ...body,
            idcourse: this.courseId,
            idlivestreamv2: this.liveId,
            type: 'LIVE',
          };
        } else if (this.typeNotice == 'COURSE') {
          body = { ...body, idcourse: this.courseId, type: 'COURSE' };
        } else if (this.typeNotice == 'EXAM') {
          body = {
            ...body,
            idcourse: this.courseId,
            idexam: this.examId,
            type: 'EXAM',
          };
        } else if (this.typeNotice == 'URL') {
          body = {
            ...body,
            type: 'URL',
          };
        } else {
          body = {
            ...body,
            type: 'GENERAL',
          };
        }

        if (this.schedule === 'sendnow') {
          let sendTimeMiili = new Date().getTime() + 60000;
          body = { ...body, timesend: sendTimeMiili };
        } else if (this.schedule === 'custom') {
          let sendTimeMiili = new Date(this.sendTime).getTime();
          body = { ...body, timesend: sendTimeMiili };
        } else if (this.schedule === 'notsend') {
          let sendTimeMiili = 0;
          body = { ...body, timesend: sendTimeMiili };
        } else if (this.schedule === 'sendeventtime') {
          let sendTimeMiili = new Date(this.startTime).getTime();
          body = { ...body, timesend: sendTimeMiili };
        } else {
          let sendTimeMiili = 0;
          body = { ...body, timesend: sendTimeMiili };
        }

        let result = await createNoticeToSendNow(body);
        if (result.code == 200) {
          this.loading = false;
        }
      }
    },
    async insertNotice() {
      this.loading = true;

      if (this.$refs.form.validate()) {
        let sendTimeMiili = null;
        let startTime = new Date(this.startTime).getTime();
        let endTime = new Date(this.endTime).getTime();

        // if (this.schedule === 'notsend') {
        //   sendTimeMiili = 0;
        // } else if (this.schedule === 'custom') {
        //   sendTimeMiili = new Date(this.sendTime).getTime();
        // } else if (this.schedule === 'sendeventtime') {
        //   sendTimeMiili = new Date(this.startTime).getTime();
        // } else {
        //   sendTimeMiili = null;
        // }
        let arrcourses = [];
        if (this.arrCourseId.length > 0) {
          this.arrCourseId.forEach((element) => {
            arrcourses.push(element.id);
          });
        }
        let arrusergroup = [];
        if (this.arrUsergroupId.length > 0) {
          this.arrUsergroupId.forEach((element) => {
            arrusergroup.push(element._id);
          });
        }
        let body = {
          title: this.title,
          body: this.message,
          url: this.url,
          image: this.imgPreview,
          target: this.targetSend,
          platform: this.platform,
          statusNotification: this.schedule,
          timesend: sendTimeMiili,
          event: {
            startTime: startTime,
            endTime: endTime,
          },
          courses: this.targetSend == 'course-usergroup' ? arrcourses : [],
          usergroup: this.targetSend == 'course-usergroup' ? arrusergroup : [],
          company:
            this.targetSend == 'all-org' ? this.$store.state.company._id : null,
        };

        if (this.typeNotice == 'LIVE') {
          body = {
            ...body,
            idcourse: this.courseId,
            idlivestreamv2: this.liveId,
            type: 'LIVE',
          };
        } else if (this.typeNotice == 'COURSE') {
          body = { ...body, idcourse: this.courseId, type: 'COURSE' };
        } else if (this.typeNotice == 'EXAM') {
          body = {
            ...body,
            idcourse: this.courseId,
            idexam: this.examId,
            type: 'EXAM',
          };
        } else if (this.typeNotice == 'URL') {
          body = {
            ...body,
            type: 'URL',
          };
        } else {
          body = {
            ...body,
            type: 'GENERAL',
          };
        }

        if (this.schedule === 'sendnow') {
          let sendTimeMiili = new Date().getTime() + 60000;
          body = { ...body, timesend: sendTimeMiili };
        } else if (this.schedule === 'custom') {
          let sendTimeMiili = new Date(this.sendTime).getTime();
          body = { ...body, timesend: sendTimeMiili };
        } else if (this.schedule === 'notsend') {
          let sendTimeMiili = 0;
          body = { ...body, timesend: sendTimeMiili };
        } else if (this.schedule === 'sendeventtime') {
          let sendTimeMiili = new Date(this.startTime).getTime();
          body = { ...body, timesend: sendTimeMiili };
        } else {
          let sendTimeMiili = 0;
          body = { ...body, timesend: sendTimeMiili };
        }

        let result = await createNoticeWithSendTime(body);
        if (result.code == 200) {
          this.loading = false;
        }
      }
    },
    async saveNotice() {
      this.loading = true;

      if (this.$refs.form.validate()) {
        let sendTimeMiili = null;
        let startTime = new Date(this.startTime).getTime();
        let endTime = new Date(this.endTime).getTime();

        if (this.schedule === 'sendnow') {
          sendTimeMiili = new Date().getTime() + 60000;
        } else if (this.schedule === 'custom') {
          sendTimeMiili = new Date(this.sendTime).getTime();
        } else if (this.schedule === 'notsend') {
          sendTimeMiili = 0;
        } else if (this.schedule === 'sendeventtime') {
          sendTimeMiili = new Date(this.startTime).getTime();
        } else {
          sendTimeMiili = 0;
        }

        let arrcourses = [];
        if (this.arrCourseId.length > 0) {
          this.arrCourseId.forEach((element) => {
            arrcourses.push(element.id);
          });
        }
        let arrusergroup = [];
        if (this.arrUsergroupId.length > 0) {
          this.arrUsergroupId.forEach((element) => {
            arrusergroup.push(element._id);
          });
        }

        let body = {
          idschedule: this.noticeId,
          title: this.title,
          body: this.message,
          url: this.url,
          image: this.imgPreview,
          target: this.targetSend,
          platform: this.platform,
          statusNotification: this.schedule,
          timesend: sendTimeMiili,
          event: {
            startTime: startTime,
            endTime: endTime,
          },
          courses: arrcourses,
          usergroup: arrusergroup,
          company:
            this.targetSend == 'all-org' ? this.$store.state.company._id : null,
        };

        if (this.typeNotice == 'LIVE') {
          body = {
            ...body,
            idcourse: this.courseId,
            idlivestreamv2: this.liveId,
            type: 'LIVE',
          };
        } else if (this.typeNotice == 'COURSE') {
          body = { ...body, idcourse: this.courseId, type: 'COURSE' };
        } else if (this.typeNotice == 'EXAM') {
          body = {
            ...body,
            idcourse: this.courseId,
            idexam: this.examId,
            type: 'EXAM',
          };
        } else if (this.typeNotice == 'URL') {
          body = {
            ...body,
            type: 'URL',
          };
        } else {
          body = {
            ...body,
            type: 'GENERAL',
          };
        }

        let result = await updateNotice(body);
        if (result.code == 200) {
          this.loading = false;
        }
      }
    },
    clearUrl() {
      if (this.url) {
        this.url = this.url.toLowerCase();
        let tmphttps = this.url.indexOf('http');
        if (tmphttps > -1) {
          this.url = this.url.replace('https://', '');
          this.url = this.url.replace('http://', '');
        }
      }
    },
    async uploadImg(file) {
      this.loading = true;
      this.showUploadPercent = true;

      let formData = new FormData();
      formData.append('fileupload', file);
      formData.append('title', file.name);
      await axios
        .post(`${domain}/uploadfile/public/image/event`, formData, {
          headers: {
            ...headersWithTokenForImage(),
          },
          onUploadProgress: function (progressEvent) {
            this.progressPercent = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then(
          async function (response) {
            this.imgPreview = response.data.result;
            this.loading = false;
          }.bind(this)
        )
        .catch(function (e) {
          console.log('FAILURE!!', e);
        });
    },
  },
};
</script>
<style scoped>
.img-panel {
  width: 100%;
  height: 120px;
  border: 2px dashed #b9b9b9;
  background: rgba(0, 0, 0, 0.02);
  /* rgba(0, 0, 0, 0.02) */
}
.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.header-label {
  height: 40px !important;
  background-color: #50adde;
}
.close_dialog {
  float: right;
  margin-right: 15px;
}
.scrollable {
  overflow-y: auto;
  max-height: calc(80vh - 90px);
}
.textField {
  width: 100%;
}
.textarea-border {
  border: 1px solid;
  border-color: rgba(65, 65, 65, 0.3);
  height: 67px;
}
.show-data-search {
  background-color: white;
}
.textSearch {
  width: 100%;
  height: 60px;
}
.page-card {
  background-color: white;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}
.datetime {
  padding: 10px;
  box-shadow: 0 0 0px 0 rgba(0, 0, 0, 0.19) !important;
  border: 1px solid #e0e0e0;
  border-radius: 5px !important;
  text-align: center;
  height: 45px;
  transition: box-shadow 0.3s ease-in-out;
}
.image-preview {
  min-height: 200px;
  border: 1px dashed rgba(0, 0, 0, 0.15) !important;
  background: #ebedf0;
}
.border-card {
  border: 1px dashed #80808040 !important;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 170px !important;
}
.btn-choose {
  color: rgba(0, 0, 0, 0.65);
  background-color: white;
  padding: 8px 20px;
  font-size: 16px;
  width: 170px !important;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
}
.upload-btn-wrapper input[type='file'] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.upload-btn-wrapper input[type='file']:hover {
  cursor: pointer;
}
</style>
<style>
.theme--dark.v-data-table thead tr th {
  color: black !important;
}
.theme--light.v-data-table tbody tr.v-data-table__selected {
  background: white !important;
}
.theme--dark.v-data-table {
  color: black !important;
}
</style>
<style lang="scss">
.headTable {
  .v-data-table-header {
    background: #cad3d8 !important;
  }
}
</style>
